// App icons for Admin › OTA Releases › Changelog.
//
// The four with art are the launcher's own feedback-screen icons, copied
// byte for byte from vortexnav-client
// vortex-launcher/app/src/main/res/drawable-nodpi/feedback_app_*.png
// (96 px, on the Scout tile blue #006AFC). PolarisOS follows the feedback
// screen's rule: a white house on that blue. System Services, Vortex Compass
// and GPS Diag have no art anywhere, so they get a white glyph on the same
// blue (approved by Jason on the design canvas, 19 Oct 2026).

import { HomeIcon } from '@heroicons/react/24/solid';
import { EllipsisHorizontalIcon, GlobeAltIcon, SignalIcon } from '@heroicons/react/24/outline';
import vortexnav from '../../../../assets/app-icons/vortexnav.png';
import vortexanchor from '../../../../assets/app-icons/vortexanchor.png';
import vortextide from '../../../../assets/app-icons/vortextide.png';
import truehelm from '../../../../assets/app-icons/truehelm.png';

/** The blue behind every Scout app tile. */
export const APP_TILE_BLUE = '#006AFC';

const ART: Record<string, string> = { vn: vortexnav, va: vortexanchor, vt: vortextide, th: truehelm };

function CompassGlyph({ size }: { size: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth={1.7} aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 5.5l2.2 6.5h-4.4z" fill="#fff" stroke="none" />
      <path d="M12 18.5l-2.2-6.5h4.4z" strokeLinejoin="round" />
    </svg>
  );
}

/** A tile's corner radius: a quarter of its size, like the Scout's. */
export const appIconRadius = (size: number) => Math.round(size / 4);

/** An app's tile at `size` px. Decorative: show the name beside it. */
export function AppIcon({ app, size }: { app: string; size: number }) {
  const box = { width: size, height: size, borderRadius: appIconRadius(size) };
  const art = ART[app];
  if (art) {
    return <img src={art} alt="" aria-hidden="true" width={size} height={size} style={box} className="block flex-none" />;
  }
  const glyph = Math.round(size * 0.6);
  const known = app === 'launcher' || app === 'wv' || app === 'vc' || app === 'gps';
  return (
    <span
      aria-hidden="true"
      style={{ ...box, background: known ? APP_TILE_BLUE : undefined }}
      className={known ? 'inline-flex flex-none items-center justify-center' : 'inline-flex flex-none items-center justify-center bg-slate-700'}
    >
      {app === 'launcher' && <HomeIcon width={glyph} height={glyph} className="text-white" />}
      {app === 'wv' && <GlobeAltIcon width={glyph} height={glyph} strokeWidth={1.7} className="text-white" />}
      {app === 'vc' && <CompassGlyph size={glyph} />}
      {app === 'gps' && <SignalIcon width={glyph} height={glyph} strokeWidth={1.7} className="text-white" />}
      {!known && <EllipsisHorizontalIcon width={glyph} height={glyph} className="text-slate-300" />}
    </span>
  );
}
